module.exports = __webpack_public_path__ + "static/media/styledDatepicker-Chevrom-Right.6ed54de2.svg";